import { EnvironmentVariableService } from '@portal/shared/helpers/src';

export enum SearchLimit {
  Threshold = EnvironmentVariableService.getVar('PDSP_EXPORT_TRANSACTION_THRESHOLD') as number,
}
